import { reactive } from "vue";
import { basins, countries, crops, scenarioCountriesLoader, scenarioCountryBasinCrops, scenarioCountryBasinCropsLoader, scenarioCountryCrops, scenarioCountryCropsLoader, scenarioCropsLoader, scenarioProcesses, scenarioProcessesLoader } from "./entity-model";

export const steps = [
  { name: "scope", title: "Home", shortTitle: "Home", index: 0 },
  { name: "accounting", title: "Accounting", shortTitle: "Acc", index: 1 },
  { name: "sustainability", title: "Sustainability", shortTitle: "Sust", index: 2 },
  { name: "response", title: "Response Formulation", shortTitle: "Resp", index: 3 }
];

export const viewTypes = {
  "map": { name: "map", icon: "map.svg" },
  "table": { name: "table", icon: "table.svg" },  // croptable,
                                                  // production account table, production account table 2, production account table 3,
                                                  // production sustain blue table, production sustain grey table,
                                                  // production respond blue table, production respond grey table
  "pie-chart": { name: "pie-chart", icon: "pie-chart.svg" },  // cropchart
  "bar-chart": { name: "bar-chart", icon: "bar-chart.svg" },  // barchart
  "hydrograph": { name: "hydrograph", icon: "hydrograph.svg" }
};

export const assessmentTypes = {
  "countries": {
    name: "countries",
    layerName: "Countries",
    idPropertyName: "countryID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: countries
  },
  "basins": {
    name: "basins",
    layerName: "Basins",
    idPropertyName: "basinID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["hydrograph"]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: basins
  },
  "world": {
    name: "world",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: null
  },
  "crops": {
    name: "crops",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["bar-chart"]
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ]
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ]
        }]
      }
    ],
    countriesOrBasins: null
  },
  "commodity": {
    name: "commodity",
    layerName: "Countries",
    idPropertyName: "countryID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey", "total" ]
        }, {
          viewType: viewTypes["bar-chart"]
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ]
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ]
        }]
      }
    ],
    countriesOrBasins: null
  },
  "business": {
    name: "business",
    layerName: "Countries",
    idPropertyName: "countryID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: ["green", "blue", "grey", "total"]
        }, {
          viewType: viewTypes["bar-chart"]
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: ["blue", "grey"]
        }, {
          viewType: viewTypes["table"],
          viewColors: ["blue", "grey"]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"]
        }]
      }
    ],
    countriesOrBasins: null
  },
  "hbasins": {
    name: "hbasins",
    layerName: "Basins",
    idPropertyName: "basinID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: ["blue", "grey"],
          hasCrops: true
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: ["blue", "grey"]
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: ["blue", "grey"],
          hasCrops: true
//        }, {
//          viewType: viewTypes["table"]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"]
        }]
      }
    ],
    countriesOrBasins: basins
  }
};

function Assessment() {
  this.assessmentType = null;
  this.step = steps[0];
  this.viewType = null;
  this.viewColor = "blue";  // Values: green, blue, grey, total
  this.countriesOrBasins = [];
  this.crop = null;
  this.scenario = null;

  this.refresh = false;

  this.branding = "wfn";
}

Assessment.prototype.setAssessmentType = function(assessmentType) {
  if (typeof assessmentType == "string") {
    assessmentType = assessmentTypes[assessmentType];
  }
  if (this.assessmentType == assessmentType) {
    return;
  }
  
  this.assessmentType = assessmentType;
  this.setStep(steps[0]);
  
  this.setCountriesOrBasins([]);
  this.crop = null;
  this.scenario = null;
}

Assessment.prototype.isGeographic = function() {
  if (this.assessmentType == null) {
    return false;
  }
  
  return (this.assessmentType.name == "countries") || (this.assessmentType.name == "basins") || (this.assessmentType.name == "world") || (this.assessmentType.name == "crops");
}

Assessment.prototype.isProduction = function() {
  if (this.assessmentType == null) {
    return false;
  }
  
  return (this.assessmentType.name == "commodity") || (this.assessmentType.name == "business");
}

Assessment.prototype.isActive = function() {
  if (this.assessmentType == null) {
    return false;
  }
  if (((this.assessmentType.name == "countries") || (this.assessmentType.name == "basins")) && (this.countriesOrBasins.length == 0)) {
    return false;
  }
  if ((this.assessmentType.name == "crops") && (this.crop == null)) {
    return false;
  }
  if (((this.assessmentType.name == "commodity") || (this.assessmentType.name == "business")) && (this.scenario == null)) {
    return false;
  }
  return true;
}

Assessment.prototype.setStep = function(step, refresh = false) {
  if (typeof step == "number") {
    step = steps[step];
  }
  if (typeof step == "string") {
    step = steps.find(s => s.name == step);
  }
  if ((this.assessmentType == null) && (step.index != 0)) {
    throw new Error("Cannot set step when there is no assessment type.");
  }

  this.refresh = refresh;
  
  this.step = step;
  this.alignViewType();
}

Assessment.prototype.nextStep = function() {
  if (this.assessmentType == null) {
    throw new Error("Cannot set next step when there is no assessment type.");
  }
  if (this.step.index == steps.length - 1) {
    throw new Error("Cannot set step beyond the last step.");
  }

  this.refresh = true;
  
  this.step = steps[this.step.index + 1];
  this.alignViewType();
}

Assessment.prototype.previousStep = function() {
  if (this.step.index == 0) {
    throw new Error("Cannot set step before the first step.");
  }

  this.refresh = true;
  
  this.step = steps[this.step.index - 1];
  this.alignViewType();
}

Assessment.prototype.setViewType = function(viewType, refresh = false) {
  if (typeof viewType == "string") {
    viewType = viewTypes[viewType];
  }
  
  this.refresh = refresh;

  this.viewType = viewType;
  this.alignViewType();
}

Assessment.prototype.alignViewType = function() {
  if (this.step.index == 0) {
    this.viewType = null;
    this.viewColor = "blue";
    return;
  }
  
  if ((this.viewType == null) || !this.assessmentType.steps[this.step.index].views.find(view => view.viewType == this.viewType)) {
    this.viewType = this.assessmentType.steps[this.step.index].views[0].viewType;
  }
  
  this.alignViewColor();
}

Assessment.prototype.setViewColor = function(viewColor, refresh = false) {
  this.refresh = refresh;

  this.viewColor = viewColor;
  this.alignViewColor();
}

Assessment.prototype.alignViewColor = function() {
  if (this.viewType == null) {
    return;
  }
  
  const view = this.assessmentType.steps[this.step.index].views.find(view => view.viewType == this.viewType);
  if (view.viewColors == null) {
    return;
  }
  
  if (view.viewColors.indexOf(this.viewColor) == -1) {
    this.viewColor = view.viewColors[0];
  }
}

Assessment.prototype.getCountryOrBasinName = function(multipleNames) {
  if (assessment.assessmentType.name == "countries") {
    if (assessment.countriesOrBasins.length == 1) {
      return assessment.countriesOrBasins[0].name;
    }
    if (multipleNames) {
      return assessment.countriesOrBasins.map((o, i, a) => (i == 0)? o.name: (i < a.length - 1)? ", " + o.name: " and " + o.name).join("");
    }
    return "the selected country";
  }
  if (assessment.assessmentType.name == "basins") {
    if (assessment.countriesOrBasins.length == 1) {
      return "the " + assessment.countriesOrBasins[0].name + " basin";
    }
    if (multipleNames) {
      return "the " + assessment.countriesOrBasins.map((o, i, a) => (i == 0)? o.name: (i < a.length - 1)? ", " + o.name: " and " + o.name).join("") + " basins";
    }
    return "the selected river basin";
  }
  return "the world";
}

Assessment.prototype.setCountriesOrBasins = function(countriesOrBasins) {
  if (
    (this.countriesOrBasins.length == countriesOrBasins.length) &&
    (this.countriesOrBasins.every((cb, i) => cb == countriesOrBasins[i]))
  ) {
    return;
  }

  this.countriesOrBasins = countriesOrBasins;
}

Assessment.prototype.setCrop = function(crop, refresh = false) {
  if (typeof crop == "number") {
    crop = crops.find(c => c.cropID == crop);
  }
  
  this.refresh = refresh;

  this.crop = crop;
}

Assessment.prototype.setScenario = function(scenario, loadEntities = true) {
  if ((this.assessmentType.name != "commodity") && (this.assessmentType.name != "business")) {
    return;
  }

  this.scenario = scenario;

  if (loadEntities) {
    this.loadScenarioBaseEntities();
    this.loadScenarioDerivedEntities();
  }
}

Assessment.prototype.loadScenarioBaseEntities = function() {
  if ((this.scenario == null) || !((this.scenario.type % 10 == 1) || (this.scenario.type % 100 >= 10))) {
    return;
  }

  if ((this.scenario.type % 10 == 1) && (this.branding != "sbtn")) {
    scenarioCountryCropsLoader.load(this.scenario.code);
  } else {
    scenarioCountryCrops.length = 0;
  }
  if (this.scenario.type % 100 >= 10) {
    scenarioProcessesLoader.load(this.scenario.code);
  } else {
    scenarioProcesses.length = 0;
  }
}

Assessment.prototype.loadScenarioDerivedEntities = function() {
  if ((this.scenario == null) || !((this.scenario.type % 10 == 1) || (this.scenario.type % 100 >= 10))) {
    return;
  }

  if (this.scenario.type % 10 == 1) {
    scenarioCountryBasinCropsLoader.load(this.scenario.code);
  } else {
    scenarioCountryBasinCrops.length = 0;
  }
  scenarioCountriesLoader.load(this.scenario.code);
  scenarioCropsLoader.load(this.scenario.code);
}

const assessmentModel = reactive({
  assessment: new Assessment()
});

export const assessment = assessmentModel.assessment;

